import { Link } from "react-router-dom";
import type { Video } from "@/types/video";
import VideoCard from "@/components/ui/VideoCard";

interface VideoGridSectionProps {
  title: string;
  subtitle?: string;
  icon?: string;
  videos: Video[];
  moreTo?: string;
  moreLabel?: string;
  columns?: 4 | 5;
}

export default function VideoGridSection({
  title,
  subtitle,
  icon = "ri-star-line",
  videos,
  moreTo,
  moreLabel = "查看更多",
  columns = 5,
}: VideoGridSectionProps) {
  const gridClass =
    columns === 4
      ? "grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 md:gap-4"
      : "grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5 md:gap-4";

  return (
    <section className="px-4 md:px-6 lg:px-8" aria-label={title}>
      <div className="mb-5 flex items-end justify-between gap-4">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-600">
              <i className={icon}></i>
            </span>
            {title}
          </h2>
          {subtitle && <p className="mt-1.5 text-sm text-foreground-600">{subtitle}</p>}
        </div>
        {moreTo && (
          <Link
            to={moreTo}
            className="inline-flex shrink-0 items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700 whitespace-nowrap"
          >
            {moreLabel}
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        )}
      </div>
      <div className={gridClass}>
        {videos.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </section>
  );
}